import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import "../../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from '../../common/ProtectedLayout';
import styled from "styled-components";
import NoticeEventImageField, { buildNoticeEventFormData } from '../notice_event_image_field';

function ManagerNoticeDetail(props) {

    const location = useLocation();
    const navigate = useNavigate();

    const [noticeList, setNoticeList] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [removeImage, setRemoveImage] = useState(false);
    const modalCorrective = useRef();

    const auth = useAuthContext();

    const startBeforePage = () => {
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const startModal = () => {
        setImageFile(null);
        setRemoveImage(false);
        modalCorrective.current.showModal();
    }

    const ChangeTitle = (e) => {
        setNoticeList({ ...noticeList, title: e.target.value });
    }
    const ChangeContent = (e) => {
        setNoticeList({ ...noticeList, content: e.target.value });
    }

    const putNoticeInfo = async () => {
        const requestData = buildNoticeEventFormData({
            title: noticeList.title,
            content: noticeList.content,
            id: auth.loginId,
            division: noticeList.division,
            imageFile,
            removeImage
        });
        try {
            const put_result = await axios.put(`/NoticeRegist/${noticeList.idx}`, requestData);
            if (put_result.data.success === true) {
                setNoticeList((current) => ({ ...current, image_url: put_result.data.image_url }));
                setImageFile(null);
                setRemoveImage(false);
                alert('수정이 완료되었습니다');
                modalCorrective.current.close();
            } else {
                alert('수정에 실패하였습니다');
            }
        } catch (error) {
            console.error('Error :', error.message);
        }
    };

    useEffect(() => {
        const getReservationDetail = async () => {
            try {
                const notice_result = await axios.get(`/NoticeRegistId/${location.state.idx}`);
                setNoticeList(notice_result.data[0]);
            } catch (error) {
                console.error('Error fetching driver notice detail:', error.message);
            }
        };
        getReservationDetail();
    }, [location.state.idx]);

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>매니저 공지사항 상세</Title>
                </CardHeader>

                <SectionTitle>게시글 정보</SectionTitle>
                <GridContainer>
                    {/* 제목 표시 */}
                    <InfoItem label="제목" value={noticeList.title} span={4} />

                    {noticeList.image_url && (
                        <div style={{ gridColumn: 'span 4' }}>
                            <Label>이미지</Label>
                            <DetailImage src={noticeList.image_url} alt="매니저 공지 첨부 이미지" />
                        </div>
                    )}

                    {/* 내용 표시 (읽기 전용 박스) */}
                    <div style={{ gridColumn: 'span 4', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Label>내용</Label>
                        <ReadOnlyTextArea style={{ minHeight: '300px' }}>
                            {noticeList.content || ''}
                        </ReadOnlyTextArea>
                    </div>
                </GridContainer>

                <ButtonGroup>
                    <OutlineButton onClick={startBeforePage}>목록으로</OutlineButton>
                    <PrimaryButton onClick={startModal}>수정하기</PrimaryButton>
                </ButtonGroup>
            </Card>

            {/* 수정 모달 */}
            <StyledDialog ref={modalCorrective}>
                <DialogHeader>
                    <h3>매니저 공지사항 수정</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <div style={{ marginBottom: '20px' }}>
                        <Label>제목</Label>
                        <StyledInput
                            value={noticeList.title || ''}
                            onChange={ChangeTitle}
                        />
                    </div>
                    <div>
                        <Label>내용 (1000자 이내)</Label>
                        <StyledTextArea
                            style={{ height: '300px' }}
                            value={noticeList.content || ''}
                            onChange={ChangeContent}
                        />
                    </div>
                    <NoticeEventImageField
                        imageFile={imageFile}
                        existingImageUrl={noticeList.image_url}
                        removeImage={removeImage}
                        onChange={({ imageFile: nextImage, removeImage: nextRemove }) => {
                            setImageFile(nextImage);
                            setRemoveImage(nextRemove);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={putNoticeInfo}>저장하기</PrimaryButton>
                </DialogActions>
            </StyledDialog>
        </PageContainer>
    )
}

// --- Helper Components ---
const InfoItem = ({ label, value, span = 1 }) => (
    <div style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Label>{label}</Label>
        <Value>{value || '-'}</Value>
    </div>
);

const DetailImage = styled.img`
    display: block;
    max-width: 100%;
    max-height: 520px;
    margin-top: 8px;
    object-fit: contain;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
`;

// --- Styled Components ---

const PageContainer = styled.div`
    padding: 20px;
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 1000px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 35px 40px;
    display: flex;
    flex-direction: column;
    gap: 25px;
`;

const CardHeader = styled.div`
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
    margin-bottom: 10px;
`;

const Title = styled.h2`
    font-size: 1.6rem;
    color: #111;
    margin: 0;
    font-weight: 800;
`;

const SectionTitle = styled.h3`
    font-size: 1.2rem;
    color: #333;
    margin: 0 0 12px 0;
    border-left: 5px solid #006edc;
    padding-left: 12px;
    font-weight: 700;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 20px;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const Label = styled.div`
    font-size: 0.95rem;
    color: #333;
    font-weight: 700;
    margin-bottom: 4px;
`;

const Value = styled.div`
    font-size: 1rem;
    color: #222;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 8px;
    min-height: 24px;
    word-break: break-all;
`;

const ReadOnlyTextArea = styled.div`
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 1rem;
    line-height: 1.6;
    color: #333;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: break-word;
    overflow-y: auto;
    overflow-x: hidden;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box;
    &:focus { border-color: #006edc; outline: none; }
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    resize: vertical;
    box-sizing: border-box;
    font-family: inherit;
    line-height: 1.6;
    word-break: break-word;
    overflow-wrap: break-word;
    &:focus { border-color: #006edc; outline: none; }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.95rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #006edc;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ccc;
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

// --- Modal Styles ---
const StyledDialog = styled.dialog`
    border: none;
    border-radius: 16px;
    padding: 0;
    width: 90%;
    max-width: 800px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 20px 25px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 { margin: 0; font-size: 1.3rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 30px;
    background: #fff;
    max-height: 80vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 20px 25px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

const CloseButton = styled.button`
    background: none; border: none; font-size: 1.8rem; cursor: pointer; color: #999; line-height: 1;
    &:hover { color: #333; }
`;

export default ManagerNoticeDetail;
